import { FC, useContext } from 'react';

import { H3, Separator, Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './PeripheralSettings.module.scss';

export const PeripheralSettings: FC = () => {
  const { t } = useContext(LocalizationContext);

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <H3>{t('settings.shell.peripheral.title')}</H3>
      <span className={s.subtitle}>
        {t('settings.shell.peripheral.description')}
      </span>
      <Separator style={{ margin: '16px 0' }} />
      <div className={s.toggle_block}>
        <div className={s.toggle}>
          <Toggle
            label={t('settings.shell.peripheral.voice')}
            value={settings.soundUtil}
            onChange={(value: boolean) =>
              setSetting({
                alias: ESettingsAliases.SOUND_UTIL,
                value: value ? '1' : '0',
              })
            }
            variant="secondary"
            emptyBg
          />
        </div>
        {/*<Toggle*/}
        {/*  label={t('setting.shell.utils.video')}*/}
        {/*  value={settings.videoUtil}*/}
        {/*  onChange={(value: boolean) =>*/}
        {/*    setSetting({*/}
        {/*      alias: ESettingsAliases.VIDEO_UTIL,*/}
        {/*      value: value ? '1' : '0',*/}
        {/*    })*/}
        {/*  }*/}
        {/*/>*/}
        <div className={s.toggle}>
          <Toggle
            label={t('settings.shell.peripheral.mouse')}
            value={settings.mouseUtil}
            onChange={(value: boolean) =>
              setSetting({
                alias: ESettingsAliases.MOUSE_UTIL,
                value: value ? '1' : '0',
              })
            }
            variant="secondary"
            emptyBg
          />
        </div>
      </div>
    </>
  );
};
